import * as XLSX from 'xlsx';

/**
 * Lit un fichier tabulaire (CSV/XLS/XLSX) et retourne une liste d'objets.
 * Utilise la première feuille pour les formats Excel.
 */
export async function parseTabularFile(file) {
  if (!file) return [];
  const name = String(file.name || '').toLowerCase();
  const isCsv = name.endsWith('.csv') || name.endsWith('.txt');
  const data = await file.arrayBuffer();
  const workbook = XLSX.read(data, {
    type: 'array',
    raw: false,
    dense: true,
    cellDates: true,
    codepage: isCsv ? 65001 : undefined,
  });
  const sheetName = workbook.SheetNames?.[0];
  if (!sheetName) return [];
  const sheet = workbook.Sheets[sheetName];
  return XLSX.utils.sheet_to_json(sheet, { defval: null });
}
